module.exports = __webpack_public_path__ + "949adea2e8b982161bcd729288da62b1.svg";